<template>
  <el-card class="lad-itinerary-download" shadow="never">
    <LadResizer
      container-class="lad-itinerary-download--wrapper"
      :max-xs-width="520"
    >
      <h2>{{ $t(`${base}.title`) }}</h2>

      <span v-if="isViatorPlatform">&nbsp;</span>
      <el-button
        v-else
        type="primary"
        icon="el-icon-download"
        plain
        @click="handleOpen"
        >{{ $t(`${base}.download`) }}</el-button
      >

      <el-button
        type="success"
        icon="el-icon-chat-round"
        plain
        @click="handleScroll"
        >{{ $t(`${base}.ask_question`) }}</el-button
      >
    </LadResizer>

    <LadItineraryDownloadDialogZoho
      v-if="dialog.show"
      :open="dialog.show"
      @close="handleClose"
    />
  </el-card>
</template>

<script>
import { mapState } from 'vuex'
import CacheComponentMixin from '@/utils/mixin/cache-components'

export default {
  name: 'LadItineraryDownload',
  components: {
    LadResizer: () =>
      import(/* webpackChunkName: "lad-resizer" */ '@/components/resizer'),
    LadItineraryDownloadDialogZoho: () =>
      import(
        /* webpackChunkName: "lad-itinerary-dialog-download-zoho" */ './components/dialog-zoho'
      ),
  },
  mixins: [CacheComponentMixin],
  data() {
    return {
      base: 'components.itinerary.download',
      dialog: {
        show: false,
      },
    }
  },
  computed: {
    ...mapState('experience', {
      isViatorPlatform: (state) => state.platform.name === 'Viator',
    }),
  },
  methods: {
    handleScroll() {
      this.$scrollTo('.experience-wrapper--container-contact-us')
    },
    handleOpen() {
      this.dialog.show = true
    },
    handleClose() {
      this.dialog.show = false
    },
  },
}
</script>

<style lang="scss">
@mixin ladItineraryDownload {
  grid-template-columns: 1fr;
  text-align: center;

  .el-button + .el-button {
    margin-left: 0;
  }
}

.lad-itinerary-download--wrapper {
  display: grid;
  grid-gap: 15px;
  align-items: center;
  grid-template-columns: 1fr auto auto;

  h2 {
    font-size: 1.2em;
  }

  &--xs {
    @include ladItineraryDownload;
  }

  @media screen and (max-width: 520px) {
    @include ladItineraryDownload;
  }
}

#front-chat-container {
  z-index: 1000 !important;
}

@media screen and (max-width: 1026px) {
  #front-chat-container #front-chat-holder > div > div {
    bottom: 100px !important;
  }
}
</style>
